import React, { useContext, useEffect, useRef, useState } from 'react';
import InformationModal from './InformationModal';
import { ReactComponent as DownArrow } from '../../assets/images/downarrowcolored.svg';
import { ReactComponent as UpArrow } from '../../assets/images/uparrowcolored.svg';
import { ReactComponent as InfoIcon } from '../../assets/images/infoIcon.svg';
import { Box } from '@mui/system';
import MediumTypography from '../../components/formlib/MediumTypography';
import Textinput from '../../components/formlib/Textinput';
import DatePickerComponent from '../../components/formlib/DatePickerComponent';
import CustomRadioButton from '../../components/formlib/CustomRadioButton';
import dayjs, { Dayjs } from 'dayjs';
import IfspContext from './ifspContextApi/IfspContex';
import DropdownComponent from '../../components/formlib/DropdownComponent';
import { OptionType } from '../../utils/type';

import { LookUpContext } from '../../context/LookUpContextProvider';
import { Grid } from '@mui/material';
import CheckBoxComponent from '../../components/formlib/CheckBoxComponent';
import { datePickerMinDateMaxDateValidate } from '../../utils/dateUtil';
import CommentTextbox from '../../components/formlib/CommentTextbox';
import { useIntl } from 'react-intl';

interface TransitionPlanProps {
  info: boolean;
  open: boolean;
  // isIfspScreenLocked: boolean;
  selectedLanguage: string;
  onClose: (open: boolean) => void;
  closeInfo: (info: boolean) => void;
  onOpen: (open: boolean) => void;
  openInfo: (info: boolean) => void;
  hasEditPermission: boolean;
}

type DateOrNull = string | null | Dayjs;

interface TransitionPlanDataType {
  isTransitionPlanDone: string;
  isTpcMeetingDone: string;
  isConsentDoneToShareInfoToLea: string;
  transitionPlanDate: DateOrNull;
  noTransitionPlanReason: string;
  needs: string;
  leaEligible: string;
  notify: string;
  consentShare: boolean;
  consentDate: DateOrNull;
  outsideTPCReason: string;
  meetingDate: DateOrNull;
  noTPCReason: string;
  sectionDetermine: boolean;
  specify: string;
  makeReferral: boolean;
  date: DateOrNull;
  tpc: boolean;
  leaInvited: string;
  repParticipate: string;
  participatedNames: string;
  noReferralMade: boolean;
  leaOptOutDate: DateOrNull;
  seaStatus: string;
}

const LEAData = [
  {
    id: 1,
    labelId: 'IFSP.LEA.4',
    defaultLabelId: 'Arrange Transition Conference (TC)',
  },
  {
    id: 2,
    labelId: 'IFSP.LEA.1',
    defaultLabelId: 'Sign consent to share information with LEA',
  },
  {
    id: 3,
    labelId: 'IFSP.LEA.2',
    defaultLabelId: 'Determine which sections of EI record to send to LEA',
  },
  {
    id: 4,
    labelId: 'IFSP.LEA.3',
    defaultLabelId:
      'Make referral to LEA/school district (between 2.3 and 2.9)',
  },
  {
    id: 5,
    labelId: 'IFSP.LEA.5',
    defaultLabelId: 'No Referral Made',
  },
];
const TransitionPlan = ({
  closeInfo,
  info,
  // isIfspScreenLocked,
  openInfo,
  open,
  onOpen,
  onClose,
  selectedLanguage,
  hasEditPermission,
}: TransitionPlanProps) => {
  const {
    ifsp,
    updateIfspContext,
    updateTransitionOutOfRange,
    UpdateLeaReferralDateOutOfRange,
    UpdateTpcMeetingDateOutOfRange,
    updateIsTransitionDateReqired,
    updateIsOptOutNotificationDateRequired,
    isOptOutNotificationDateRequired,
    isTransitionDateReqired,
    isTpcMeetingDateRequired,
    isLeaReferralDateRequired,
    updateIsLeaReferralDateRequired,
    updateIsTpcMeetingDateRequired,
    tpcMeetingDateOutOfRange,
    transitionDateOutOfRange,
    leaReferralDateOutOfRange,
  } = useContext(IfspContext);
  const [transitionPlan, setTransitionPlan] = useState<TransitionPlanDataType>(
    ifsp.ifspTeam.forms.transitionPlan,
  );
  const [transitionReasondata, setTransitionReasondata] = useState<
    OptionType[]
  >([]);
  const [leaReferralReasonData, setLeaReferralReasonData] = useState<
    OptionType[]
  >([]);
  const [tpcReasonData, setTpcReasonData] = useState<OptionType[]>([]);
  const [seaStatus, setSeaStatus] = useState<OptionType[]>([]);
  const rctl = useIntl();
  const { lookups } = useContext(LookUpContext);
  const parentRef = useRef<HTMLDivElement>(null);
  const permission = hasEditPermission && selectedLanguage === 'en';

  useEffect(() => {
    if (!permission) {
      const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Tab') {
          e.preventDefault();
        }
      };
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [permission]);

  useEffect(() => {
    if (lookups === null) {
      return;
    }

    setTransitionReasondata(() => {
      return lookups.transitionReason.map((r) => {
        return {
          label: r.description,
          id: r.code,
        };
      });
    });
    setLeaReferralReasonData(() => {
      return lookups.leaReferralReason.map((r) => {
        return {
          label: r.description,
          id: r.code,
        };
      });
    });
    setTpcReasonData(() => {
      return lookups.tpcReason.map((r) => {
        return {
          label: r.description,
          id: r.code,
        };
      });
    });
    setSeaStatus(() => {
      return lookups.seaStatus.map((r) => {
        return {
          label: r.description,
          id: r.code,
        };
      });
    });
  }, [lookups]);

  useEffect(() => {
    updateIfspContext({
      ...ifsp,
      ifspTeam: {
        ...ifsp.ifspTeam,
        forms: {
          ...ifsp.ifspTeam.forms,
          transitionPlan: transitionPlan,
        },
      },
    });
  }, [transitionPlan]);

  useEffect(() => {
    const newTransitionPlan = ifsp.ifspTeam.forms
      .transitionPlan as TransitionPlanDataType;
    if (JSON.stringify(newTransitionPlan) !== JSON.stringify(transitionPlan)) {
      setTransitionPlan(newTransitionPlan);
    }
  }, [ifsp]);

  useEffect(() => {
    if (ifsp.client.dob && ifsp.ifspTeam.forms.transitionPlan.date) {
      const dob = dayjs(ifsp.client.dob, 'MM/DD/YYYY'); // Parse dob
      const monthsDiff = dayjs(ifsp.ifspTeam.forms.transitionPlan.date).diff(
        dob,
        'month',
      ); // Exact month difference

      const thirtySixMonthsFromDob = dob.add(36, 'month');
      const ninetyDaysBeforeThirtySixMonths = thirtySixMonthsFromDob.subtract(
        90,
        'day',
      );

      if (monthsDiff < 27) {
        UpdateLeaReferralDateOutOfRange(true);
      } else if (
        dayjs(ifsp.ifspTeam.forms.transitionPlan.date).isAfter(
          ninetyDaysBeforeThirtySixMonths,
        )
      ) {
        UpdateLeaReferralDateOutOfRange(true);
      } else {
        UpdateLeaReferralDateOutOfRange(false);
      }
    }

    if (
      ifsp.client.dob &&
      ifsp.ifspTeam.forms.transitionPlan.transitionPlanDate
    ) {
      const dob = dayjs(ifsp.client.dob, 'MM/DD/YYYY'); // Parse dob
      const monthsDiff = dayjs(
        ifsp.ifspTeam.forms.transitionPlan.transitionPlanDate,
      ).diff(dob, 'month'); // Exact month difference

      const thirtySixMonthsFromDob = dob.add(36, 'month');
      const ninetyDaysBeforeThirtySixMonths = thirtySixMonthsFromDob.subtract(
        90,
        'day',
      );

      if (monthsDiff < 27) {
        updateTransitionOutOfRange(true);
      } else if (
        dayjs(ifsp.ifspTeam.forms.transitionPlan.transitionPlanDate).isAfter(
          ninetyDaysBeforeThirtySixMonths,
        )
      ) {
        updateTransitionOutOfRange(true);
      } else {
        updateTransitionOutOfRange(false);
      }
    }

    if (ifsp.client.dob && ifsp.ifspTeam.forms.transitionPlan.meetingDate) {
      const dob = dayjs(ifsp.client.dob, 'MM/DD/YYYY'); // Parse dob
      const monthsDiff = dayjs(
        ifsp.ifspTeam.forms.transitionPlan.meetingDate,
      ).diff(dob, 'month'); // Exact month difference

      const thirtySixMonthsFromDob = dob.add(36, 'month');
      const ninetyDaysBeforeThirtySixMonths = thirtySixMonthsFromDob.subtract(
        90,
        'day',
      );

      if (monthsDiff < 27) {
        UpdateTpcMeetingDateOutOfRange(true);
      } else if (
        dayjs(ifsp.ifspTeam.forms.transitionPlan.meetingDate).isAfter(
          ninetyDaysBeforeThirtySixMonths,
        )
      ) {
        UpdateTpcMeetingDateOutOfRange(true);
      } else {
        UpdateTpcMeetingDateOutOfRange(false);
      }
    }
  }, []);

  return (
    <Box component="main">
      {info && (
        <InformationModal
          open={info}
          titleLabel="IFSP.Information"
          titleDefaultLabel="Information"
          buttonLabel="IFSP.InfoOkButton"
          buttonDefaultLabel="Ok"
          onClose={() => {
            closeInfo(info);
          }}
          info={
            "Early Intervention services may occur for less than the specified period based on the child's age at the time of the eligibility evaluation. All EI services end one day prior to the child's third birthday. Transition planning occurs for all infants and toddlers who are moving on from an EI program. As part of the IFSP, a transition plan is developed to consider and identify the steps and services to support a smooth transition. This process includes activities and tasks discussed by the IFSP Team."
          }
        />
      )}
      <Box
        component="section"
        className="p-lg borderRadius4 "
        sx={{
          border: '1px solid #00C6B8',
          backgroundColor: '#ECF9F8',
        }}
      >
        <Box component="div" className="flex__justify__space-between">
          {open ? (
            <Box component="div" className="flex__justify__space-between">
              <MediumTypography
                labelid="IFSP.session7"
                defaultlabel="Transition Plan"
                fontSize="16px"
                fontweight={600}
                textColor="#2A4241"
                className="pr-md"
              />
              <InfoIcon
                className="cursorPointer"
                onClick={() => {
                  openInfo(info);
                }}
              />
            </Box>
          ) : (
            <MediumTypography
              labelid="IFSP.session7"
              defaultlabel="Transition Plan"
              fontSize="18px"
              fontweight={600}
              textColor="#2A4241"
            />
          )}
          {!open ? (
            <DownArrow
              className="cursorPointer"
              style={{ color: '#008C82' }}
              onClick={() => {
                onOpen(open);
              }}
            />
          ) : (
            <UpArrow
              className="cursorPointer"
              onClick={() => {
                onClose(open);
              }}
            />
          )}
        </Box>
        {open && (
          <Box component="div" className="mt-lg">
            <Box
              ref={parentRef}
              style={{
                pointerEvents: permission ? 'auto' : 'none',
                opacity: permission ? 'unset' : '0.8',
              }}
            >
              <Grid container rowSpacing={'24px'}>
                <Grid item>
                  <MediumTypography
                    labelid="EICS.TransitionPlan"
                    defaultlabel={`Transition Plan `}
                    fontSize="14px"
                  />
                </Grid>
                <Grid item className="ml-lg">
                  <CustomRadioButton
                    needUnSelect
                    data={[
                      {
                        value: 'Yes',
                        labelId: 'Yes',
                        defaultLabel: 'Yes',
                      },
                      {
                        value: 'No',
                        labelId: 'No',
                        defaultLabel: 'No',
                      },
                    ]}
                    value={transitionPlan.isTransitionPlanDone}
                    onSelectItem={(value) => {
                      if (value === 'No' || value === null) {
                        updateIsTransitionDateReqired(false);
                        if (value === null) {
                          updateTransitionOutOfRange(false);
                        } else {
                          updateTransitionOutOfRange(true);
                        }
                        setTransitionPlan({
                          ...transitionPlan,
                          isTransitionPlanDone: value ?? '',
                          transitionPlanDate: null,
                        });
                      } else {
                        updateIsTransitionDateReqired(true);
                        updateTransitionOutOfRange(false);
                        setTransitionPlan({
                          ...transitionPlan,
                          isTransitionPlanDone: value ?? '',
                        });
                      }
                    }}
                    row={true}
                  />
                </Grid>
                <Grid item width={'384px'}>
                  <DatePickerComponent
                    className="bg__white"
                    labelid="EICS.TransitionPlandate"
                    disableFuture={false}
                    required={true}
                    defaultlabelid="Date of Transition Plan*"
                    value={
                      transitionPlan.transitionPlanDate === '' ||
                      transitionPlan.transitionPlanDate === null ||
                      transitionPlan.transitionPlanDate === 'No'
                        ? null
                        : dayjs(transitionPlan.transitionPlanDate)
                    }
                    handlechange={(dateValue: Dayjs | null) => {
                      const formattedDate =
                        dayjs(dateValue).format('MM/DD/YYYY');
                      if (dateValue !== null) {
                        setTransitionPlan({
                          ...transitionPlan,
                          transitionPlanDate: formattedDate,
                        });
                        if (!datePickerMinDateMaxDateValidate(dateValue)) {
                          updateIsTransitionDateReqired(false);
                        } else {
                          updateIsTransitionDateReqired(true);
                        }
                        const dob = dayjs(ifsp.client.dob, 'MM/DD/YYYY'); // Parse dob
                        const monthsDiff = dateValue.diff(dob, 'month'); // Exact month difference

                        const thirtySixMonthsFromDob = dob.add(36, 'month');
                        const ninetyDaysBeforeThirtySixMonths =
                          thirtySixMonthsFromDob.subtract(90, 'day');

                        if (monthsDiff < 27) {
                          updateTransitionOutOfRange(true);
                        } else if (
                          dateValue.isAfter(ninetyDaysBeforeThirtySixMonths)
                        ) {
                          updateTransitionOutOfRange(true);
                        } else {
                          updateTransitionOutOfRange(false);
                        }
                      } else {
                        if (transitionPlan.isTransitionPlanDone === 'Yes') {
                          updateIsTransitionDateReqired(true);
                        }
                        if (transitionPlan.isTransitionPlanDone === 'No') {
                          updateTransitionOutOfRange(true);
                        } else {
                          updateTransitionOutOfRange(false);
                        }
                        setTransitionPlan({
                          ...transitionPlan,
                          transitionPlanDate: null,
                        });
                      }
                    }}
                    disabledDate={transitionPlan.isTransitionPlanDone !== 'Yes'}
                  />
                  {isTransitionDateReqired && (
                    <Box className="loginError">
                      <MediumTypography
                        labelid={
                          datePickerMinDateMaxDateValidate(
                            transitionPlan.transitionPlanDate,
                          )
                            ? 'datePickerMinDateMaxDateValidate'
                            : ' IFSP.DateOfTransitionPlanIsRequired'
                        }
                        defaultlabel={'Date of Transition Plan is required'}
                        className="errorText-md"
                      />
                    </Box>
                  )}
                </Grid>
              </Grid>
              <Box>
                <Grid
                  container
                  rowSpacing={'24px'}
                  className="pt-md pb-sm align__items__center"
                >
                  <Grid item width={'615px'}>
                    <DropdownComponent
                      name="noTransitionPlanReason"
                      names={transitionReasondata}
                      value={transitionPlan.noTransitionPlanReason}
                      defaultlabelid="Reason for “No transition plan” or outside “expected” timeframe"
                      labelid="EICS.TransitionPlanDropdown"
                      handleChange={(value: string) => {
                        if (value) {
                          setTransitionPlan({
                            ...transitionPlan,
                            noTransitionPlanReason: value,
                          });
                        } else {
                          setTransitionPlan({
                            ...transitionPlan,
                            noTransitionPlanReason: '',
                          });
                          if (transitionPlan.isTransitionPlanDone === 'No') {
                            updateIsTransitionDateReqired(false);
                            updateTransitionOutOfRange(true);
                          }
                        }
                      }}
                      disabled={!permission}
                      placeholderOnfloatBackgroundColor="#E7F0F0"
                    />
                    <MediumTypography
                      labelid="EICS.TransitionPlanDropDownLabel"
                      sxProps={{ fontStyle: 'italic' }}
                      defaultlabel={
                        'The reason is required as the child is below 27 months and less than 90 days from their 3rd birthday'
                      }
                      fontSize="14px"
                    />
                    {transitionDateOutOfRange &&
                      !transitionPlan.noTransitionPlanReason && (
                        <Box>
                          <MediumTypography
                            labelid={'IFSP.NoTransitionPlanReasonRequired'}
                            defaultlabel={
                              'Reason for “No transition plan” or outside “expected” timeframe'
                            }
                            sxProps={{
                              color: 'red',
                            }}
                          />
                        </Box>
                      )}
                  </Grid>
                </Grid>
              </Box>
              <Box sx={{ borderBottom: '1px solid #97A6A5' }} className="pb-md">
                <MediumTypography
                  labelid="IFSP.responsible"
                  defaultlabel="What do we need to do? Who is responsible?"
                  fontweight={400}
                  textColor="#2A4241"
                />
                <CommentTextbox
                  placeholder={rctl.formatMessage({
                    id: 'IFSP.enterYourComment',
                    defaultMessage: 'Enter your comment',
                  })}
                  className="bg__white translate"
                  rows={5}
                  style={{
                    width: '615px',
                    textAlign: 'justify',
                  }}
                  maxLength={5000}
                  Value={transitionPlan.needs}
                  handlechange={(text) =>
                    setTransitionPlan({ ...transitionPlan, needs: text })
                  }
                />
              </Box>
              <MediumTypography
                labelid="IFSP.tPC"
                defaultlabel="Transition Conference (TC):"
                fontSize="16px"
                fontweight={600}
                textColor="#2A4241"
                className="pt-md"
              />
              <Box className="flex__ pt-sm align__items__center">
                <MediumTypography
                  labelid="IFSP.meetingDate...."
                  defaultlabel="TPC Meeting:"
                  fontweight={400}
                  textColor="#2A4241"
                />
                <CustomRadioButton
                  needUnSelect
                  data={[
                    {
                      value: 'Yes',
                      labelId: 'Yes',
                      defaultLabel: 'Yes',
                    },
                    {
                      value: 'No',
                      labelId: 'No',
                      defaultLabel: 'No',
                    },
                  ]}
                  value={transitionPlan.isTpcMeetingDone}
                  onSelectItem={(value) => {
                    if (value === 'No' || value === null) {
                      updateIsTpcMeetingDateRequired(false);
                      if (value === null) {
                        UpdateTpcMeetingDateOutOfRange(false);
                      } else {
                        UpdateTpcMeetingDateOutOfRange(true);
                      }
                      setTransitionPlan({
                        ...transitionPlan,
                        isTpcMeetingDone: value ?? '',
                        meetingDate: null,
                      });
                    } else {
                      updateIsTpcMeetingDateRequired(true);
                      UpdateTpcMeetingDateOutOfRange(false);
                      setTransitionPlan({
                        ...transitionPlan,
                        isTpcMeetingDone: value ?? '',
                      });
                    }
                  }}
                  row={true}
                  className="ml-md"
                />
              </Box>
              <Box component="div" className="flex__ pt-lg">
                <MediumTypography
                  labelid="IFSP.meetingDate"
                  defaultlabel="Meeting Date:"
                  fontweight={400}
                  textColor="#2A4241"
                  className="mr-md"
                />
                <Box>
                  <Box component="div" sx={{ width: '176px' }}>
                    <DatePickerComponent
                      className="bg__white"
                      labelid={'IFSP.meetingDate'}
                      defaultlabelid={'Meeting Date'}
                      value={
                        transitionPlan.meetingDate === '' ||
                        transitionPlan.meetingDate === null ||
                        transitionPlan.meetingDate === 'No'
                          ? null
                          : dayjs(transitionPlan.meetingDate)
                      }
                      handlechange={(dateValue: Dayjs | null) => {
                        if (dateValue !== null) {
                          const formattedDate =
                            dayjs(dateValue).format('MM/DD/YYYY');
                          setTransitionPlan({
                            ...transitionPlan,
                            meetingDate: formattedDate,
                          });
                          if (!datePickerMinDateMaxDateValidate(dateValue)) {
                            updateIsTpcMeetingDateRequired(false);
                          } else {
                            updateIsTpcMeetingDateRequired(true);
                          }
                          const dob = dayjs(ifsp.client.dob, 'MM/DD/YYYY'); // Parse dob
                          const monthsDiff = dateValue.diff(dob, 'month'); // Exact month difference

                          const thirtySixMonthsFromDob = dob.add(36, 'month');
                          const ninetyDaysBeforeThirtySixMonths =
                            thirtySixMonthsFromDob.subtract(90, 'day');

                          if (monthsDiff < 27) {
                            UpdateTpcMeetingDateOutOfRange(true);
                          } else if (
                            dateValue.isAfter(ninetyDaysBeforeThirtySixMonths)
                          ) {
                            UpdateTpcMeetingDateOutOfRange(true);
                          } else {
                            UpdateTpcMeetingDateOutOfRange(false);
                          }
                        } else {
                          if (transitionPlan.isTpcMeetingDone === 'No') {
                            UpdateTpcMeetingDateOutOfRange(true);
                          } else {
                            UpdateTpcMeetingDateOutOfRange(false);
                          }
                          if (transitionPlan.isTpcMeetingDone === 'Yes') {
                            updateIsTpcMeetingDateRequired(true);
                          } else {
                            updateIsTpcMeetingDateRequired(false);
                          }
                          setTransitionPlan({
                            ...transitionPlan,
                            meetingDate: null,
                          });
                        }
                      }}
                      disabledDate={transitionPlan.isTpcMeetingDone !== 'Yes'}
                    />
                  </Box>
                  {isTpcMeetingDateRequired && (
                    <Box className="loginError">
                      <MediumTypography
                        labelid={
                          datePickerMinDateMaxDateValidate(
                            transitionPlan.meetingDate,
                          )
                            ? 'datePickerMinDateMaxDateValidate'
                            : ' IFSP.DateOfTransitionPlanIsRequired'
                        }
                        defaultlabel={'Meeting Date is required'}
                        className="errorText-md"
                      />
                    </Box>
                  )}
                </Box>
              </Box>
              <Grid
                container
                rowSpacing={'24px'}
                className="pt-xlg align__items__center"
              >
                <Grid item width={'615px'}>
                  <DropdownComponent
                    name="noTPCReason"
                    names={tpcReasonData}
                    value={transitionPlan.noTPCReason}
                    defaultlabelid="Reason for 'No TPC' or outside 'expected' time frame"
                    labelid="EICS.ReasonNoTPCOccoured"
                    handleChange={(value: string) => {
                      if (value) {
                        setTransitionPlan({
                          ...transitionPlan,
                          noTPCReason: value,
                        });
                      } else {
                        setTransitionPlan({
                          ...transitionPlan,
                          noTPCReason: '',
                        });
                        if (value === 'No') {
                          updateIsTpcMeetingDateRequired(false);
                          UpdateTpcMeetingDateOutOfRange(true);
                        }
                      }
                    }}
                    disabled={!permission}
                    placeholderOnfloatBackgroundColor="#E7F0F0"
                  />
                  {tpcMeetingDateOutOfRange && !transitionPlan.noTPCReason && (
                    <Box className="loginError">
                      <MediumTypography
                        labelid={'IFSP.NoReasonTpcOccuredIsRequired'}
                        defaultlabel={
                          'Reason for "No TC" or outside "expected" time frame is required'
                        }
                        className="errorText-md"
                      />
                    </Box>
                  )}
                </Grid>
                <Grid item xs={0.3}></Grid>
              </Grid>
              {LEAData.map((qus) => {
                let isChecked = false;

                if (qus.id === 1) {
                  isChecked = transitionPlan.tpc;
                } else if (qus.id === 2) {
                  isChecked = transitionPlan.consentShare;
                } else if (qus.id === 3) {
                  isChecked = transitionPlan.sectionDetermine;
                } else if (qus.id === 4) {
                  isChecked = transitionPlan.makeReferral;
                } else if (qus.id === 5) {
                  isChecked = transitionPlan.noReferralMade;
                }
                return (
                  <Box component="div" key={qus.id}>
                    <Box
                      component="div"
                      className="flex__ pt-sm align__items__center"
                    >
                      <CheckBoxComponent
                        ischecked={isChecked}
                        CheckHandleChange={(value) => {
                          setTransitionPlan((prevTransitionPlan) => ({
                            ...prevTransitionPlan,
                            consentShare:
                              qus.id === 2
                                ? value.target.checked
                                : prevTransitionPlan.consentShare,
                            sectionDetermine:
                              qus.id === 3
                                ? value.target.checked
                                : prevTransitionPlan.sectionDetermine,
                            makeReferral:
                              qus.id === 4
                                ? value.target.checked
                                : prevTransitionPlan.makeReferral,
                            tpc:
                              qus.id === 1
                                ? value.target.checked
                                : prevTransitionPlan.tpc,
                            noReferralMade:
                              qus.id === 5
                                ? value.target.checked
                                : prevTransitionPlan.noReferralMade,
                          }));
                        }}
                        labelid={qus.labelId}
                        defaultlabelid={qus.defaultLabelId}
                      />
                    </Box>
                    {qus.id === 1 && (
                      <>
                        <Box
                          component="div"
                          className="pt-sm flex__ align__items__center"
                        >
                          <CheckBoxComponent
                            labelid="IFSP.representativeInvited"
                            defaultlabelid="Was the LEA/school district representative invited?"
                            ischecked={transitionPlan.leaInvited === 'true'}
                            CheckHandleChange={(value) => {
                              console.log(value.target.checked, 'value');
                              if (!value.target.checked) {
                                setTransitionPlan({
                                  ...transitionPlan,
                                  leaInvited: 'false',
                                });
                              } else {
                                setTransitionPlan({
                                  ...transitionPlan,
                                  leaInvited: 'true',
                                });
                              }
                            }}
                          />
                        </Box>
                        <Box
                          component="div"
                          className="flex__ align__items__center pt-md"
                        >
                          <CheckBoxComponent
                            labelid="IFSP.LEA/SchoolParticipate"
                            defaultlabelid="Did the LEA/School District Representative Participate?"
                            ischecked={transitionPlan.repParticipate === 'yes'}
                            CheckHandleChange={(value) => {
                              if (!value.target.checked) {
                                setTransitionPlan({
                                  ...transitionPlan,
                                  repParticipate: 'no',
                                });
                              } else {
                                setTransitionPlan({
                                  ...transitionPlan,
                                  repParticipate: 'yes',
                                });
                              }
                            }}
                          />
                        </Box>
                        <Box>
                          <MediumTypography
                            labelid="IFSP.whoParticipated"
                            defaultlabel="Who participated?"
                            fontweight={400}
                            textColor="#2A4241"
                            className="pt-md"
                          />
                          <CommentTextbox
                            placeholder={rctl.formatMessage({
                              id: 'IFSP.enterYourComment',
                              defaultMessage: 'Enter your comment',
                            })}
                            className="bg__white translate"
                            rows={5}
                            style={{
                              width: '615px',
                              textAlign: 'justify',
                            }}
                            maxLength={500}
                            Value={transitionPlan.participatedNames}
                            handlechange={(text) =>
                              setTransitionPlan({
                                ...transitionPlan,
                                participatedNames: text,
                              })
                            }
                          />
                        </Box>
                        <Box
                          sx={{ borderTop: '1px solid #97A6A5' }}
                          className="mt-md"
                        ></Box>
                        <Box
                          component="div"
                          className="flex__ align__items__center pt-md"
                        >
                          <MediumTypography
                            labelid="IFSP.referralToLocalEducationAgency"
                            defaultlabel="Referral to Local Education Agency (LEA/School District)"
                            fontSize="16px"
                            fontweight={600}
                            textColor="#2A4241"
                            className="pr-md"
                          />
                        </Box>
                        <MediumTypography
                          labelid="IFSP.completeThisSectionOnly"
                          defaultlabel="Complete this section ONLY for children who are potentially eligible for LEA"
                          fontSize="14px"
                          sxProps={{
                            fontStyle: 'italic',
                          }}
                          className="pt-sm"
                        />
                        <MediumTypography
                          labelid="IFSP.steps"
                          defaultlabel="Steps that we need to take before age 2.9:"
                          fontSize="16px"
                          fontweight={600}
                          textColor="#2A4241"
                          className="pt-sm pb-sm"
                        />
                        <Grid
                          container
                          rowSpacing={'24px'}
                          className=" align__items__center"
                        >
                          <Grid item>
                            <MediumTypography
                              labelid="EICS.PotentiallyLEAEligible"
                              defaultlabel={`Potentially LEA eligible `}
                              fontSize="14px"
                            />
                          </Grid>
                          <Grid item className="ml-lg">
                            <CustomRadioButton
                              needUnSelect
                              data={[
                                {
                                  value: 'Yes',
                                  labelId: 'Yes',
                                  defaultLabel: 'Yes',
                                },
                                {
                                  value: 'No',
                                  labelId: 'No',
                                  defaultLabel: 'No',
                                },
                              ]}
                              value={transitionPlan.leaEligible}
                              onSelectItem={(value) => {
                                if (value === 'No' || value === null) {
                                  setTransitionPlan({
                                    ...transitionPlan,
                                    leaEligible: value ?? '',
                                    notify: '',
                                  });
                                } else {
                                  setTransitionPlan({
                                    ...transitionPlan,
                                    leaEligible: value ?? '',
                                  });
                                }
                              }}
                              row={true}
                            />
                          </Grid>
                        </Grid>
                        {transitionPlan.leaEligible === 'Yes' ? (
                          <Box component="div">
                            <CustomRadioButton
                              data={[
                                {
                                  value: 'true',
                                  labelId: 'IFSP.notify',
                                  defaultLabel: `Notify the LEA/SEA of my child's potential eligibility`,
                                },
                                {
                                  value: 'false',
                                  labelId: 'IFSP.noNotify',
                                  defaultLabel:
                                    'Parent choose to opt out of notification',
                                },
                              ]}
                              value={transitionPlan.notify}
                              onSelectItem={(value) => {
                                if (value) {
                                  setTransitionPlan({
                                    ...transitionPlan,
                                    notify: value,
                                  });
                                } else if (value === null) {
                                  setTransitionPlan({
                                    ...transitionPlan,
                                    leaEligible: '',
                                    notify: '',
                                  });
                                }
                              }}
                              row={false}
                              paddingY="4px"
                            />
                          </Box>
                        ) : null}
                      </>
                    )}
                    {qus.id === 2 && (
                      <>
                        <Box className="flex__ pt-sm align__items__center">
                          <MediumTypography
                            labelid={'IFSP.dateOfConsen...t'}
                            defaultlabel={'LEA Consent:'}
                            fontweight={400}
                            textColor="#2A4241"
                            className="pr-md"
                          />
                          <CustomRadioButton
                            needUnSelect
                            data={[
                              {
                                value: 'Yes',
                                labelId: 'Yes',
                                defaultLabel: 'Yes',
                              },
                              {
                                value: 'No',
                                labelId: 'No',
                                defaultLabel: 'No',
                              },
                            ]}
                            value={transitionPlan.isConsentDoneToShareInfoToLea}
                            onSelectItem={(value) => {
                              console.log(value);
                              if (value === 'No' || value === null) {
                                UpdateLeaReferralDateOutOfRange(false);
                                updateIsLeaReferralDateRequired(false);
                                setTransitionPlan({
                                  ...transitionPlan,
                                  isConsentDoneToShareInfoToLea: value ?? '',
                                  consentDate: null,
                                });
                              } else {
                                UpdateLeaReferralDateOutOfRange(false);
                                updateIsLeaReferralDateRequired(true);
                                setTransitionPlan({
                                  ...transitionPlan,
                                  isConsentDoneToShareInfoToLea: value ?? '',
                                });
                              }
                            }}
                            row={true}
                          />
                        </Box>
                        {transitionPlan.isConsentDoneToShareInfoToLea ===
                          'Yes' && (
                          <Box component="div" className="pt-sm flex__">
                            <MediumTypography
                              labelid={'IFSP.dateOfConsent'}
                              defaultlabel={'Date of Consent:'}
                              fontweight={400}
                              textColor="#2A4241"
                              className="pr-md"
                            />
                            <Box>
                              <Box component="div" sx={{ width: '176px' }}>
                                <DatePickerComponent
                                  className="bg__white"
                                  labelid={'IFSP.dateOfConsent'}
                                  defaultlabelid={'Date of Consent'}
                                  value={
                                    transitionPlan.consentDate === '' || null
                                      ? null
                                      : dayjs(transitionPlan.consentDate)
                                  }
                                  handlechange={(dateValue: Dayjs | null) => {
                                    if (dateValue !== null) {
                                      const formattedDate =
                                        dayjs(dateValue).format('MM/DD/YYYY');
                                      if (
                                        !datePickerMinDateMaxDateValidate(
                                          dateValue,
                                        )
                                      ) {
                                        updateIsLeaReferralDateRequired(false);
                                      } else {
                                        updateIsLeaReferralDateRequired(true);
                                      }
                                      setTransitionPlan({
                                        ...transitionPlan,
                                        consentDate: formattedDate,
                                      });
                                    } else {
                                      if (
                                        transitionPlan.isConsentDoneToShareInfoToLea ===
                                        'Yes'
                                      ) {
                                        updateIsLeaReferralDateRequired(true);
                                      } else {
                                        updateIsLeaReferralDateRequired(false);
                                      }
                                      setTransitionPlan({
                                        ...transitionPlan,
                                        consentDate: null,
                                      });
                                    }
                                  }}
                                />
                              </Box>
                              {isLeaReferralDateRequired && (
                                <Box className="loginError">
                                  <MediumTypography
                                    labelid={
                                      datePickerMinDateMaxDateValidate(
                                        transitionPlan.consentDate,
                                      )
                                        ? 'datePickerMinDateMaxDateValidate'
                                        : ' IFSP.DateOfTransitionPlanIsRequired'
                                    }
                                    defaultlabel={'Consent Date is required'}
                                    className="errorText-md"
                                  />
                                </Box>
                              )}
                            </Box>
                          </Box>
                        )}
                      </>
                    )}
                    {qus.id === 3 && (
                      <Box
                        component="div"
                        className="pt-sm flex__ align__items__center"
                      >
                        <MediumTypography
                          labelid={'IFSP.specify'}
                          defaultlabel={'Specify:'}
                          fontweight={400}
                          textColor="#2A4241"
                          className="pr-md"
                        />
                        <Textinput
                          placeHolder="Specify here.."
                          sxProps={{
                            width: '553px',
                            backgroundColor: '#ffffff',
                          }}
                          Value={transitionPlan.specify}
                          inputProps={{
                            className: 'translate',
                            maxLength: 500,
                          }}
                          handlechange={(text) =>
                            setTransitionPlan({
                              ...transitionPlan,
                              specify: text,
                            })
                          }
                        />
                      </Box>
                    )}
                    {qus.id === 4 && (
                      <>
                        <Box component="div" className="pt-sm flex__">
                          <MediumTypography
                            labelid={'IFSP.dateOfReferralLea'}
                            defaultlabel={'Date of Referral to LEA:'}
                            fontweight={400}
                            textColor="#2A4241"
                            className="pr-md"
                          />
                          <Box>
                            <Box component="div" sx={{ width: '220px' }}>
                              <DatePickerComponent
                                className="bg__white"
                                labelid={'IFSP.dateOfReferralLeaPicker'}
                                defaultlabelid={'Date of Referral to LEA'}
                                value={
                                  transitionPlan.date === '' || null
                                    ? null
                                    : dayjs(transitionPlan.date)
                                }
                                handlechange={(dateValue: Dayjs | null) => {
                                  if (dateValue !== null) {
                                    const formattedDate =
                                      dateValue.format('MM/DD/YYYY');
                                    setTransitionPlan({
                                      ...transitionPlan,
                                      date: formattedDate,
                                    });

                                    const dob = dayjs(
                                      ifsp.client.dob,
                                      'MM/DD/YYYY',
                                    ); // Parse dob
                                    const monthsDiff = dateValue.diff(
                                      dob,
                                      'month',
                                    ); // Exact month difference

                                    const thirtySixMonthsFromDob = dob.add(
                                      36,
                                      'month',
                                    );
                                    const ninetyDaysBeforeThirtySixMonths =
                                      thirtySixMonthsFromDob.subtract(
                                        90,
                                        'day',
                                      );

                                    if (monthsDiff < 27) {
                                      UpdateLeaReferralDateOutOfRange(true);
                                    } else if (
                                      dateValue.isAfter(
                                        ninetyDaysBeforeThirtySixMonths,
                                      )
                                    ) {
                                      UpdateLeaReferralDateOutOfRange(true);
                                    } else {
                                      UpdateLeaReferralDateOutOfRange(false);
                                    }
                                  } else {
                                    UpdateLeaReferralDateOutOfRange(false);
                                    setTransitionPlan({
                                      ...transitionPlan,
                                      date: null,
                                    });
                                  }
                                }}
                              />
                            </Box>
                            {datePickerMinDateMaxDateValidate(
                              transitionPlan.date,
                            ) && (
                              <Box className="loginError">
                                <MediumTypography
                                  labelid={'datePickerMinDateMaxDateValidate'}
                                  defaultlabel={
                                    'Enter a date between 01/01/1900 and 01/01/2100'
                                  }
                                  className="errorText-md"
                                />
                              </Box>
                            )}
                          </Box>
                        </Box>
                        <Box>
                          <Grid
                            container
                            rowSpacing={'24px'}
                            className="pt-xlg align__items__center"
                          >
                            <Grid item width={'615px'}>
                              <DropdownComponent
                                name="leaReferralReason"
                                names={leaReferralReasonData}
                                value={transitionPlan.outsideTPCReason}
                                defaultlabelid="Reason if LEA referral is outside of standard timeframe (27-33 mo)"
                                labelid="EICS.LEADropDown"
                                handleChange={(value: string) => {
                                  setTransitionPlan({
                                    ...transitionPlan,
                                    outsideTPCReason: value,
                                  });
                                }}
                                disabled={!permission}
                                placeholderOnfloatBackgroundColor="#E7F0F0"
                              />
                              {leaReferralDateOutOfRange &&
                                !transitionPlan.outsideTPCReason && (
                                  <Box className="loginError">
                                    <MediumTypography
                                      labelid={'IFSP.LEAReferralReasonRequired'}
                                      defaultlabel={
                                        'Reason if LEA referral is outside of standard timeframe (27-33 mo) is required'
                                      }
                                      className="errorText-md"
                                    />
                                  </Box>
                                )}
                            </Grid>
                          </Grid>
                        </Box>
                      </>
                    )}
                  </Box>
                );
              })}
              <Box>
                <Grid
                  container
                  rowSpacing={'24px'}
                  className="pt-md align__items__center"
                >
                  <Grid item width={'615px'}>
                    <DropdownComponent
                      name="leaReferralReason"
                      names={seaStatus}
                      value={transitionPlan.seaStatus}
                      defaultlabelid="SEA Status"
                      labelid="IFSP.SEAStatus"
                      handleChange={(value: string) => {
                        if (value !== 'OPTOUT') {
                          setTransitionPlan({
                            ...transitionPlan,
                            seaStatus: value,
                            leaOptOutDate: '',
                          });
                        } else {
                          setTransitionPlan({
                            ...transitionPlan,
                            seaStatus: value,
                          });
                        }
                        if (
                          value === 'OPTOUT' &&
                          (transitionPlan.leaOptOutDate === null ||
                            transitionPlan.leaOptOutDate === '' ||
                            !dayjs(transitionPlan.leaOptOutDate).isValid())
                        ) {
                          updateIsOptOutNotificationDateRequired(true);
                        } else {
                          updateIsOptOutNotificationDateRequired(false);
                        }
                      }}
                      disabled={!permission}
                      placeholderOnfloatBackgroundColor="#E7F0F0"
                    />
                  </Grid>
                </Grid>
              </Box>
              <Box component="div" className="pt-md flex__">
                <MediumTypography
                  labelid={'IFSP.LeaOptoutDateTitle'}
                  defaultlabel={'LEA Opt-out Notification date:'}
                  fontweight={400}
                  textColor="#2A4241"
                  className="pr-md"
                />
                <Box component="div" sx={{ width: '260px' }}>
                  <DatePickerComponent
                    required={transitionPlan.seaStatus === 'OPTOUT'}
                    className="bg__white"
                    labelid={'IFSP.LeaOptoutDate'}
                    defaultlabelid={'LEA Opt-out Notification date'}
                    value={
                      transitionPlan.leaOptOutDate === null ||
                      transitionPlan.leaOptOutDate === ''
                        ? null
                        : dayjs(transitionPlan.leaOptOutDate as Dayjs)
                    }
                    handlechange={(value) => {
                      if (value !== null) {
                        const formattedDate = dayjs(value).format('MM/DD/YYYY');
                        setTransitionPlan({
                          ...transitionPlan,
                          leaOptOutDate: formattedDate,
                        });
                        if (
                          !dayjs(formattedDate).isValid() &&
                          transitionPlan.seaStatus === 'OPTOUT'
                        ) {
                          updateIsOptOutNotificationDateRequired(true);
                        } else {
                          updateIsOptOutNotificationDateRequired(false);
                        }
                      } else {
                        if (transitionPlan.seaStatus === 'OPTOUT') {
                          updateIsOptOutNotificationDateRequired(true);
                        } else {
                          updateIsOptOutNotificationDateRequired(false);
                        }
                        setTransitionPlan({
                          ...transitionPlan,
                          leaOptOutDate: '',
                        });
                      }
                    }}
                    disabledDate={transitionPlan.seaStatus !== 'OPTOUT'}
                  />
                  {isOptOutNotificationDateRequired && (
                    <Box className="loginError">
                      <MediumTypography
                        labelid={'IFSP.LeaOptoutDateRequired'}
                        defaultlabel={
                          'LEA Opt-out notification date is required.'
                        }
                        className="errorText-md"
                      />
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default TransitionPlan;
